import React from "react"
import Script from "next/script"
import { Col } from "react-bootstrap"

function VideoTour({ property }) {
    return (
        <Col xs={12} className="px-0 pt-2">
            <div className="video fallback-video">
                {property.virtual_tours[0] && (
                    <iframe
                        title={property.property_ref + " Virtual Tour"}
                        src={property.virtual_tours[0]?.virtual_tour_embed}
                        className="sp-video h-100"
                        frameBorder="0"
                        allow="autoplay; picture-in-picture;"
                        allowFullScreen
                        loading="lazy"
                    ></iframe>
                )}
            </div>
            <Script
                src="https://player.vimeo.com/api/player.js"
                strategy="lazyOnload"
                nonce="Ijcm4rGLkQ"
            />
        </Col>
    )
}

export default VideoTour
